import { render, staticRenderFns } from "./ProviderContactChangeStatusButtons.vue?vue&type=template&id=1aa02e3f&"
import script from "./ProviderContactChangeStatusButtons.vue?vue&type=script&lang=js&"
export * from "./ProviderContactChangeStatusButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports